import {createDecorator} from 'vue-class-component';

// Decorator for component property that will act as a proxy for something stored in this.widgetData
/**
 * Marks a component property to become a proxy for data stored in this.widgetData, use only on DashboardWidget derived classes
 * @param {Function} [factory] - Initial value factory function.
 * @returns {PropertyDecorator}
 */
export default function WidgetData(factory) {
    return createDecorator((component, name) => {
        if (typeof(component.computed) !== 'object') {
            component.computed = Object.create(null);
        }
        component.computed[name] = {
            get() {
                if (this.widgetData) {
                    return this.widgetData[name];
                } else {
                    return null;
                }
            },
            set(newValue) {
                if (this.widgetData) {
                    this.$set(this.widgetData, name, newValue);
                } else {
                    console.error('this.widgetData does not exist, are you sure the component inherits from DashboardWidget?');
                }
            }
        };
        if (factory) {
            if (!Array.isArray(component.mixins)) {
                component.mixins = [];
            }
            component.mixins.push({
                created() {
                    // After a widget is dragged around, the v-model already has populated the widgetData
                    // We only want to run the factory if the widgetData entry is empty.
                    // We do not do boolean evaluation because someone might store a boolean (false) in there
                    // Only way to know is if it is truly not set to any value (undefined)
                    if (this[name] === undefined) {
                        this[name] = factory(this);
                    }
                }
            });
        }
    });
}



// WEBPACK FOOTER //
// ./src/components/widgets/WidgetDataDecorator.js